module.exports = __webpack_public_path__ + "static/media/TEN.e25691df.png";